import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "$background",
  },
  card: {
    backgroundColor: "$survey_card",
  },
  thankYouScreenContainer: {
    flex: 1,
    flexDirection: "column",
    minHeight: "100vh",
    flexWrap: "wrap",
  },
  container: {
    alignItems: "center",
    marginTop: "30vh",
  },
  thankYouMsg: {
    flex: 1,
    flexGrow: 1,
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
  },
  poweredByContainer: {
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    marginBottom: "3vh",
  },
  thankYouText: {
    fontSize: "$thankyou_text_size",
    fontFamily: "$thankyou_text_style",
    textAlign: "center",
    color: "$question_text",
  },
  text: {
    fontSize: "$thankyou_text_size",
    fontFamily: "$thankyou_text_style",
    marginTop: "5vh",
    textAlign: "center",
    color: "$question_text",
  },
  logo: {
    width: "$width_logo",
    height: "$height_logo",
  },
  thankYouLogo: {
    width: "$width_logo",
    height: "$height_logo",
    marginLeft: "auto",
    marginRight: "auto",
  },
});
